import { Text } from '@linktr.ee/arbor/components/Text';
import { Trans, useTranslation } from 'react-i18next';

interface IDisclaimer {
  showMarketingCopy?: boolean;
  center?: boolean;
}

const Disclaimer = ({ showMarketingCopy, center }: IDisclaimer) => {
  const { t } = useTranslation();

  const privacyLink = (
    <a
      className="underline"
      href="https://linktr.ee/s/privacy/"
      target="_blank"
      rel="noopener noreferrer"
    >
      {t('privacy notice')}
    </a>
  );

  const termsLink = (
    <a
      className="underline"
      href="https://linktr.ee/s/terms/"
      target="_blank"
      rel="noopener noreferrer"
    >
      {t('T&Cs')}
    </a>
  );

  const cookieLink = (
    <a
      className="underline"
      href="https://linktr.ee/s/about/cookie-notice"
      target="_blank"
      rel="noopener noreferrer"
    >
      {t('cookie notice')}
    </a>
  );

  const contentKey = showMarketingCopy
    ? "By clicking <bold>Create account</bold>, you agree to Linktree's <privacyLink>privacy notice</privacyLink>, <termsLink>T&Cs</termsLink> and to receive offers, news and updates."
    : "By clicking <bold>Create account</bold>, you agree to Linktree's <privacyLink>privacy notice</privacyLink>, <termsLink>T&Cs</termsLink>, <cookieLink>cookie notice</cookieLink> and to receive offers, news and updates.";

  return (
    <div className={`pt-4 ${center ? 'text-center' : ''}`}>
      <Text
        as="p"
        variant="caption-large-regular"
        className="text-gray-500 leading-relaxed"
      >
        <Trans
          i18nKey={contentKey}
          components={{
            bold: <strong />,
            privacyLink,
            termsLink,
            cookieLink,
          }}
        />
      </Text>
    </div>
  );
};

export default Disclaimer;
